<template>
  <b-navbar
    toggleable="lg"
    class="navbar navbar-expand-lg navbar-light bg-light"
  >
   <div class="container overflow-visible">
      <div class="nav-item language d-flex align-items-center">
        <LanguageSwitcher></LanguageSwitcher>

        <a class="nav-link regular" target="_blank" :href="$t('holdingPath')">
          <img
            src="@/assets/img/holding-icon.svg"
            alt="Holding icon"
            width="12"
            height="12"
          />
          TAV Holding
        </a>
      </div>

      <b-navbar-brand class="navbar-brand">
        
         <router-link :to="`/${$i18n.locale}`" active-class="active" exact>
            <a><img
          :src="$t('logoPath')"
          :alt="$t('windowTitle.base')"
          width="auto"
          height="35"
        /></a>
          </router-link>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"> </b-navbar-toggle>

      <b-collapse id="nav-collapse" class="main-nav navbar-collapse" is-nav>
        <b-navbar-nav class="navbar-nav ml-auto">
          <router-link
            :to="`/${$i18n.locale}`"
            tag="li"
            active-class="active"
            class="nav-item"
            exact
            ><a class="nav-link">{{ $t("home") }}</a></router-link
          >

          <b-nav-item-dropdown 
            active-class="active" 
            class="nav-item" 
            v-for="navItem in navItems" 
            v-bind:key="navItem._id" :class="{'router-link-active': subIsActive('/parent')}">
          <template v-slot:button-content>
            <span>{{ navItem.value }}</span>
          </template>
                <li v-for="subNavItem of navItem.subDynamicFields"  v-bind:key="subNavItem.slug">
                  <b-dropdown-item v-if="(subNavItem.slug == 'haberler')" :to="{name: 'PressRoomTR', params: {slug:navItem.slug} }">
                    {{ subNavItem.value }}
                  </b-dropdown-item>
                  <b-dropdown-item v-else-if="(subNavItem.slug == 'news')" :to="{name: 'PressRoom', params: {slug:navItem.slug} }">
                    {{ subNavItem.value }}
                  </b-dropdown-item>
                  <b-dropdown-item v-else-if="(subNavItem.slug == 'basinda-tav-akademi')" :to="{name: 'TAVAcademyInPressTR', params: {slug:navItem.slug} }">
                    {{ subNavItem.value }}
                  </b-dropdown-item>
                  <b-dropdown-item v-else-if="(subNavItem.slug == 'tav-academy-in-press')" :to="{name: 'TAVAcademyInPress', params: {slug:navItem.slug} }">
                    {{ subNavItem.value }}
                  </b-dropdown-item>
                  <b-dropdown-item v-else-if="(subNavItem.slug == 'feedback-message-box')" :to="{name: 'Feedback', params: {slug:navItem.slug} }">
                    {{ subNavItem.value }}
                  </b-dropdown-item>
                  <b-dropdown-item v-else-if="(subNavItem.slug == 'gorus-ve-onerileriniz')" :to="{name: 'FeedbackTR', params: {slug:navItem.slug} }">
                    {{ subNavItem.value }}
                  </b-dropdown-item>
                  <b-dropdown-item v-else-if="(subNavItem.slug == 'gelisim-programlarimiz')" :to="{name: 'OurProgramsTR', params: {slug:navItem.slug} }">
                    {{ subNavItem.value }}
                  </b-dropdown-item>
                  <b-dropdown-item v-else-if="(subNavItem.slug == 'job-application')" href="https://tavguvenlik.com/en-EN/human-resources/job-application" target="_blank">
                    {{ subNavItem.value }}
                  </b-dropdown-item>
                  <b-dropdown-item v-else-if="(subNavItem.slug == 'is-basvurusu')" href="https://tavguvenlik.com/tr-TR/insan-kaynaklari/is-basvuru-formu" target="_blank">
                    {{ subNavItem.value }}
                  </b-dropdown-item>
                   <b-dropdown-item v-else-if="(subNavItem.slug == 'duyurular')" :to="{name: 'AnnouncementsTR', params: {slug:navItem.slug} }">
                    {{ subNavItem.value }}
                  </b-dropdown-item>
                   <b-dropdown-item v-else-if="(subNavItem.slug == 'announcements')" :to="{name: 'Announcements', params: {slug:navItem.slug} }">
                    {{ subNavItem.value }}
                  </b-dropdown-item>
                  <b-dropdown-item v-else-if="(subNavItem.slug == 'sikca-sorulan-sorular')" :to="{name: 'FrequentlyAskedTR', params: {slug:navItem.slug} }">
                    {{ subNavItem.value }}
                  </b-dropdown-item>
                   <b-dropdown-item v-else-if="(subNavItem.slug == 'frequently-asked-questions')" :to="{name: 'FrequentlyAsked', params: {slug:navItem.slug} }">
                    {{ subNavItem.value }}
                  </b-dropdown-item>


                  <b-dropdown-item v-else :to="{name: 'PageDetails', params: {slug:navItem.slug, pageDetailSlug: subNavItem.slug} }" v-bind:key="subNavItem._id"> 
                    {{ subNavItem.value }}
                  </b-dropdown-item>
                </li>
        </b-nav-item-dropdown>

          <!--<router-link 
            :to="{name: 'Pages', params: {slug:navItem.slug} }"
            tag="li" 
            active-class="active" 
            class="nav-item" 
            v-for="navItem in navItems" 
            v-bind:key="navItem._id">
            <a class="nav-link">{{ navItem.value }}</a>
          </router-link>-->

          <!--
              :to="`/${$i18n.locale}/`+ navItem.slug" 
              
              <router-link
            :to="`/${$i18n.locale}/corporate`"
            tag="li"
            active-class="active"
            class="nav-item"
            ><a class="nav-link">KURUMSAL</a></router-link
          >
          <router-link
            :to="`/${$i18n.locale}/linesofactivity`"
            tag="li"
            active-class="active"
            class="nav-item"
            ><a class="nav-link">FAALİYET ALANLARIMIZ</a></router-link
          >
          <router-link
            :to="`/${$i18n.locale}/pressroom`"
            tag="li"
            active-class="active"
            class="nav-item"
            ><a class="nav-link">BASIN ODASI</a></router-link
          >
          <router-link
            :to="`/${$i18n.locale}/humanresources`"
            tag="li"
            active-class="active"
            class="nav-item"
            ><a class="nav-link">İNSAN KAYNAKLARI</a></router-link
          >
          <router-link
            :to="`/${$i18n.locale}/contactus`"
            tag="li"
            active-class="active"
            class="nav-item"
            ><a class="nav-link">İLETİŞİM</a></router-link
          >

          <b-nav-item href="#">
            <a class="nav-link text-right" href="#">
              <img
                src="@/assets/img/search-icon.svg"
                alt="Search icon"
                width=""
                height=""
              />
            </a>
          </b-nav-item>-->
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
import ContentService from "@/services/ContentService.js";
import LanguageSwitcher from "@/components/shared/LanguageSwitcher.vue";

export default {
  data() {
    return {
      navItems: [],
      pageSlug: this.$route.params.slug
    };
  },
   components: {
      LanguageSwitcher,
   },
  created() {
     ContentService.getNavigation(this.$application, this.$t("languageCode"))
      .then((res) => (this.navItems = res.data.data.subDynamicFields))
      .catch((error) => console.log("There was an error:" + error));
  },
  methods: {
  subIsActive(input) {
    const paths = Array.isArray(input) ? input : [input]
    return paths.some(path => {
      return this.$route.path.indexOf(path) === 0 // current path starts with this path string
    })
  }
}

};

</script>

<style scoped>

</style>
